import { BulkSelectionMutation, BulkSelectionObjectCreationObject } from "../../hooks";

import request from "../base-request";

export type ISelectionObject = {
	warnings: string[];
	errors: string[];
	result: {
		document_count: number;
		bulk_selection_id: string;
	};
};

export type ISelectionObjectResponse = {
	errors: string[];
	warnings: string[];
	result: {
		_id: string;
		bulk_selection: {
			company_id: string;
			created_at: string;
			deleted_at?: string;
			updated_at?: string;
			type: string;
			object_ids: string[];
		};
	};
};

/**
 * Creates a new selection object
 * @returns The ID of the new selection object
 */
export const fetchNewBulkSelectionObjectID = async (
	type: string,
	bulkSelectionObjectCreationObject: BulkSelectionObjectCreationObject
) => {
	const payload = bulkSelectionObjectCreationObject?.object_ids?.length
		? { type, object_ids: bulkSelectionObjectCreationObject.object_ids }
		: { type, query: bulkSelectionObjectCreationObject.query };

	const [data] = await request<ISelectionObject>("/api/bulk-selections", {
		method: "POST",
		body: JSON.stringify(payload),
	});

	return data;
};

export const fetchBulkSelections = async (selectionObjectID: string) => {
	if (selectionObjectID) {
		const [data] = await request<ISelectionObjectResponse>(`/api/bulk-selections/${selectionObjectID}/`, {
			method: "GET",
		});

		return data;
	} else {
		return {} as ISelectionObjectResponse;
	}
};

export const mutateItemsInBulkSelection = async (
	selectionObjectID: string,
	bulkSelectionMutationObject: BulkSelectionMutation
) => {
	const [data] = await request<{ bulk_selection_id: string; document_count: number }>(
		`/api/bulk-selections/${selectionObjectID}`,
		{
			method: "PUT",
			body: JSON.stringify(bulkSelectionMutationObject),
		}
	);

	return data;
};

export const applyBulkUpdate = async (selectionObjectID: string, type: string, bulkUpdateObject: any) => {
	const [data] = await request<{ bulk_selection_id: string; document_count: number }>(
		`/api/bulk-selections/${selectionObjectID}/update`,
		{
			method: "POST",
			body: JSON.stringify({ service: type, updates: bulkUpdateObject }),
		}
	);

	return data;
};
